import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = ["disabled", "aria-label"]

import { ProductionGroup } from '@/types';

// The yellow-heart favorite toggle shown on a group's table row - identical in the "all groups" and
// "by section" DataTable, so one definition serves both instead of two copies drifting apart.

export default /*@__PURE__*/_defineComponent({
  __name: 'GroupFavoriteToggle',
  props: {
    group: {},
    pending: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "rounded-full p-1 transition-colors hover:bg-gray-100 disabled:cursor-default disabled:opacity-50",
      disabled: _ctx.pending,
      "aria-label": _ctx.group.is_favorite ? _ctx.$t('views.monitoring.groupOverview.tables.barnTable.favorite.remove') : _ctx.$t('views.monitoring.groupOverview.tables.barnTable.favorite.add'),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('toggle', _ctx.group)), ["stop"]))
    }, [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        class: _normalizeClass(["size-7", { 'text-yellow-400': _ctx.group.is_favorite, 'text-gray-200 hover:text-gray-300': !_ctx.group.is_favorite }])
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
          "clip-rule": "evenodd"
        }, null, -1)
      ]), 2))
    ], 8, _hoisted_2)
  ]))
}
}

})